"use strict";

import Page from "./PosRover";

export const auth = true;

export const Component = Page;
